export const shouldShowWhatsNewPopup = (BANNER_KEY: string, BANNER_VERSION: string, MIN_WINS: number) => {
    const getBannerState = () => {
        const state = localStorage.getItem(BANNER_KEY);
        return state ? JSON.parse(state) : null;
    };

    const wins = parseInt(localStorage.getItem("wins") || "0");
    const state = getBannerState();

    console.log("Banner Debug:", {
        wins,
        state,
        BANNER_VERSION,
        MIN_WINS,
        hasEnoughWins: wins >= MIN_WINS,
        localStorage: localStorage.getItem(BANNER_KEY),
    });

    if (!state) {
        console.log("First time user check");
        // If they have enough wins, show current banner
        if (wins >= MIN_WINS) {
            console.log("First time user with enough wins - showing banner");
            return true;
        }

        // If they don't have enough wins, mark this version as seen
        console.log("First time user without enough wins - marking as seen");
        const newState = {
            version: BANNER_VERSION,
            wins: wins,
            seen: true,
        };
        localStorage.setItem(BANNER_KEY, JSON.stringify(newState));
        return false;
    }

    // Returning user - only show if version is different
    const shouldShow = state.version !== BANNER_VERSION;
    console.log("Returning user check:", {
        storedVersion: state.version,
        currentVersion: BANNER_VERSION,
        shouldShow,
    });
    return shouldShow;
}

export const markBannerShown = (BANNER_KEY: string, BANNER_VERSION: string) => {
    const state = {
        version: BANNER_VERSION,
        wins: parseInt(localStorage.getItem("wins") || "0"),
        seen: true,
    };
    
    localStorage.setItem(BANNER_KEY, JSON.stringify(state));
}